export default {
  loading: "Loading...",
  error403: "You don't have access",
  showMore: "Show more",
  catalogBtn: "Catalogue of services",
  searchPlaceholder: "Catalog search",
  searchBtn: "Search",
  currencyTitle: "Currency",
  standTitle: "Stand",
  empty: "Empty",
  addToCart: "To cart",

  servicesSumWithVat: "Sum with VAT",
  recommendedService: "This service is ordered with",

  serviceModal: {
    noPriceNotice:
      "N/A – Some services do not have a price. Please contact the manager",
    backBtn: "Back",
    datesRequired: "Select dates",
    servicesSum: "Services cost"
  },

  cart: {
    pageTitle: "Cart",
    empty: "Your cart is empty",
    goToCatalog: "Catalog",
    goToMainPage: "Main page",
    deleteFromCart: "Delete from cart",
    chooseDate: "Select the service delivery dates",
    chooseTimeRange: "Select the service delivery times",
    createOrder: "Place an order",
    comment: "Service comment",
    commentInputPlaceholder:
      "If necessary, specify the stand № and other service parameters"
  },

  ordering: {
    pageTitle: "Processing",
    standSelectTitle: "Select from the list",
    standSelectPreheader: "Stand",
    pavilion: "Pavilion",
    hall: "Hall",
    comment: "Order comment",
    commentInputPlaceholder:
      "If necessary, specify the stand № and other service parameters",
    commentSubtitle: "Max 250 characters",
    requiredContract:
      "It is required to sign a contract for the provision of communication services. This is in accordance with the Rules for the provision of telematics services.",
    needContract: "Make a contract",
    is_edo:
      "Use Electronic document management Контур.Диадок system about the exchange of acceptance certificates on the order (only for Russian companies).",
    needContractSubtitle:
      "Tick the box if you need to make a separate contract for additional services",
    submitBtn: "Submit an order",

    success: "Order sent successfully",
    orderNumber: "Order № {id} as of {date}",

    counterparty: {
      title: "Contractor (payer) details",
      choose: "Select contractor (payer)",
      name: "Contractor (payer) name",
      inn: "Registration №",
      kpp: "KPP",
      legalAddress: "Legal address",
      address: "Address",
      bik: "BIK",
      bank: "Bank",
      bankAccount: "Bank account",
      corAccount: "Correspondent account",
      showFull: "Show full",
      showLess: "Hide",
      addBtn: "Add contractor (payer)"
    },

    customer: {
      title: "About Client",
      lastname: "Lastname",
      name: "Name",
      middlename: "Middlename",
      email: "E-mail",
      phone: "Phone"
    }
  },

  orders: {
    pageTitle: "My orders",
    viewOrders: "View My orders",
    activeOrdersTab: "Active",
    archiveOrdersTab: "Archive",

    orderStatus: "Order status",
    statusSelectTitle: "Select from the list",

    confirmOrder: "Confirm",
    cancelOrder: "Cancel order",
    downloadOrder: "Download order",
    downloadInvoice: "Download invoice",
    managerTitle: "Responsible manager",
    managerPhone: "Phone",
    ordersContractorExpo:
      "The order successfully submitted and will soon be considered by the responsible manager.\n" +
      "Keep track of the order status changes.",
    ordersContractorAnother:
      "The order has been submitted to an authorised partner for execution. It will soon be reviewed by the responsible specialist who will invoice you for the services."
  },

  chat: {
    you: "You",
    inputPlaceholder: "Message",
    today: "Today",
    yesterday: "Yesterday",
    advice: "You can ask questions about your order",
    sizeKb: "KB",
    sizeMb: "MB"
  },

  search: {
    pageTitle: "Search",
    results: "Found: {count}"
  },

  popularServices: {
    title: "Popular services",
    showAll: "Show all",
    description:
      "The cost of services in case of late order (during the exhibition mounting) will be increased",
    servicePricePerPiece: "pc",
    popularServiceEnd:
      'Ordering additional services in the personal account is not available. For more information, please contact the Service Bureau at  <a href="tel:+74997953779">+7 (499) 428-03-00</a> or by e-mail at <a href="mailto:usluga@expocentr.ru">usluga@expocentr.ru</a>',
    serviceTimeEnd: "Ordering services in personal account is completed"
  }
};
